import { useTheme} from '@mui/material/styles';

export const getActionProps = (type, sx = {}) => {
    const theme = useTheme();
    const themeColour = theme.palette[type];

    const props = {
        variant: 'contained',
        color: type,
        sx: {
            backgroundColor: themeColour.main,
            color: themeColour.contrastText,
            ':hover': {
                backgroundColor: themeColour.dark,
                color : themeColour.contrastTextDark,
            },    
            border: `1px solid ${themeColour.contrastText}`, 
            ...sx,
        },
    }

    return props;
}